module.exports = __webpack_public_path__ + "static/Disinfection-service-whocanuseit-35b01e350c0d2b3111ef566dfa05bd4b.png";